import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  TextInput,
} from "react-native";
import Dropdown from "../component/dropdown";
import * as ImagePicker from "expo-image-picker";
import { FontAwesome, Entypo, Feather } from "@expo/vector-icons";
import { CalendarPicker, RangePicker } from "react-minimal-datetime-range";
import "react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css";
import {
  authActionCreateCompe,
  authActionCreateEvent,
  authActionPutCompe,
  deleteEvent,
} from "../action/authAction";
import NumberFormat from "react-number-format";
import { useRecoilState } from "recoil";
import { tokenState } from "../reducer/recoil";
import { apiservice } from "../service";
import { useIsFocused } from "@react-navigation/native";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Modal from "modal-react-native-web";
let selectData = ["SINGLE ROOM", "TWIN ROOM", "TRIPPLE ROOM", "QUADRUBLE ROOM"];
const { width, height } = Dimensions.get("window");

export default function compeCreate({
  navigation,
  textButtonSend,
  textButtonSave,
  route,
}) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [modalVisible, setModalVisible] = useState(false);
  const [validation, setValidation] = useState({
    valid1: false,
    valid2: false,
    valid3: false,
    valid4: false,
    valid5: false,
    valid6: false,
  });
  const [checkboxAll, setCheckBoxAll] = useState(false);
  const [checkboxAllMale, setCheckBoxAllMale] = useState(false);
  const [checkboxAllFemale, setCheckBoxAllFemale] = useState(false);
  const [selectCountries, setSelectCountries] = useState([]);
  const [selectEventMale, setSelectEventMale] = useState([]);
  const [selectEventFemale, setSelectEventFemale] = useState([]);
  const [generationIndex, setGenerationIndex] = useState(0);
  const [showCalendarPrelimStart, setShowCalendarPrelimStart] = useState(false);
  const [showCalendarPrelimEnd, setShowCalendarPrelimEnd] = useState(false);
  const [showCalendarFinalStart, setShowCalendarFinalStart] = useState(false);
  const [showCalendarFinalEnd, setShowCalendarFinalEnd] = useState(false);
  const [showCalendarMailPrelim, setShowCalendarMailPrelim] = useState(false);
  const [showCalendarMailFinal, setShowCalendarMailFinal] = useState(false);
  const [showCalendarLimitAgeStart, setShowCalendarLimitAgeStart] =
    useState(false);
  const [showCalendarLimitAgeEnd, setShowCalendarLimitAgeEnd] = useState(false);
  const [showCalendarPostStart, setShowCalendarPostStart] = useState(false);
  const [showCalendarPostEnd, setShowCalendarPostEnd] = useState(false);
  const TODAY = new Date();
  const [prelimYearStart, setPrelimYearStart] = useState(TODAY.getFullYear());
  const [prelimMonthStart, setPrelimMonthStart] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [prelimDateStart, setPrelimDateStart] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [prelimYearEnd, setPrelimYearEnd] = useState(TODAY.getFullYear());
  const [prelimMonthEnd, setPrelimMonthEnd] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [prelimDateEnd, setPrelimDateEnd] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );

  const [finalYearStart, setFinalYearStart] = useState(TODAY.getFullYear());
  const [finalMonthStart, setFinalMonthStart] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [finalDateStart, setFinalDateStart] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [finalYearEnd, setFinalYearEnd] = useState(TODAY.getFullYear());
  const [finalMonthEnd, setFinalMonthEnd] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [finalDateEnd, setFinalDateEnd] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );

  const [mailYearPrelim, setMailYearPrelim] = useState(TODAY.getFullYear());
  const [mailMonthPrelim, setMailMonthPrelim] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [mailDatePrelim, setMailDatePrelim] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [mailYearFinal, setMailYearFinal] = useState(TODAY.getFullYear());
  const [mailMonthFinal, setMailMonthFinal] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [mailDateFinal, setMailDateFinal] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [limitAgeYearStart, setLimitAgeYearStart] = useState(
    TODAY.getFullYear()
  );
  const [limitAgeMonthStart, setLimitAgeMonthStart] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [limitAgeDateStart, setLimitAgeDateStart] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [limitAgeYearEnd, setLimitAgeYearEnd] = useState(TODAY.getFullYear());
  const [limitAgeMonthEnd, setLimitAgeMonthEnd] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [limitAgeDateEnd, setLimitAgeDateEnd] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );

  const [postYearStart, setPostYearStart] = useState(TODAY.getFullYear());
  const [postMonthStart, setPostMonthStart] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [postDateStart, setPostDateStart] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [postYearEnd, setPostYearEnd] = useState(TODAY.getFullYear());
  const [postMonthEnd, setPostMonthEnd] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [postDateEnd, setPostDateEnd] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const [imageName, setImageName] = useState("");
  const [year, setYear] = useState(TODAY.getFullYear());
  const [month, setMonth] = useState(
    (TODAY.getMonth() + 1).toString().length > 1
      ? TODAY.getMonth() + 1
      : "0" + (TODAY.getMonth() + 1)
  );
  const [date, setDate] = useState(
    TODAY.getDate().toString().length > 1
      ? TODAY.getDate()
      : "0" + TODAY.getDate()
  );
  const generationList = ["SENIOR", "YOUTH", "JUNIOR"];
  const generationChangeHandler = (index) => {
    setGenerationIndex((preIndex) => index);
    setStateCompe({
      ...stateCompe,
      generation: index == 0 ? "Senior" : index == 1 ? "Youth" : "Junior",
    });
  };
  const [keyindex, setkeyindex] = useState(Math.floor(Math.random() * 100 + 1));
  const [keyindexMale, setkeyindexMale] = useState(
    Math.floor(Math.random() * 100 + 1)
  );

  const [keyindexFemale, setkeyindexFemale] = useState(
    Math.floor(Math.random() * 100 + 1)
  );

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });
    if (!result.cancelled) {
      console.log(result);
      setStateCompe({ ...stateCompe, image: result.uri });
      setImageName(result.uri);
    }
  };

  const [AddEventMale, setAddEventMale] = useState({
    event_name: "",
    event_gender: "Male",
    event_status: "Active",
  });

  async function EventMale() {
    setModalVisible(true);
    if (AddEventMale.event_name.length > 0) {
      const Event = await authActionCreateEvent(AddEventMale, token);
      recallgetCountriesEvent();
      setModalVisible(!modalVisible);
    }
  }

  const [time, setTime] = useState({
    timeHourPrelimStart: "00",
    timeMinutePrelimStart: "00",
    timeHourPrelimEnd: "00",
    timeMinutePrelimEnd: "00",
    timeHourPrelimSendMail: "00",
    timeMinutePrelimSendmail: "00",
    timeHourFinalStart: "00",
    timeMinuteFinalStart: "00",
    timeHourFinalEnd: "00",
    timeMinuteFinalEnd: "00",
    timeHourFinalSendMail: "00",
    timeMinuteFinalSendmail: "00",
    timeHourPostStart: "00",
    timeMinutePostStart: "00",
    timeHourPostEnd: "00",
    timeMinutePostEnd: "00",
    timeMinuteLimitAgeStart: "00",
    timeHourLimitAgeStart: "00",
    timeMinuteLimitAgeEnd: "00",
    timeHourLimitAgeEnd: "00",
  });

  const [stateCompe, setStateCompe] = useState({
    host_id: null,
    competition_name: "",
    description: "",
    image: "",
    prelim_start_date: null,
    prelim_end_date: null,
    final_start_date: null,
    final_end_date: null,
    prelim_mail_date: null,
    final_mail_date: null,
    prelim_status: "Pending",
    final_status: "Pending",
    generation: "Senior",
    limit_age_start: null,
    limit_age_end: null,
    pose_start: null,
    pose_end: null,
    allow_countries: [],
    events_male: route.params == undefined ? [] : route.params.events_male,
    events_female: route.params == undefined ? [] : route.params.events_female,
    room_type_request:
      route.params == undefined ? [] : route.params.room_type_request,
  });

  const [informationCountry, setInformationCountry] = useState([]);
  const [informationEvent, setInformationEvent] = useState([]);
  const [nameCom, setNameCom] = useState("");
  const [descomp, setDesCom] = useState("");
  const [CKEdit, setCKEdit] = useState("");

  useEffect(() => {
    getCountriesEvent();
    if (route.params != undefined) {
      console.log("route.params");
      setStateCompe(route.params);
      setStateCompe({
        ...route.params,
        competition_name: route.params.name,
        description: route.params.description,
        events_male: route.params.events_male,
        events_female: route.params.events_female,
      });
      setNameCom(route.params.name);
      setDesCom(route.params.description);
      setImageName(
        route.params.image_url != null ? route.params.image_url : ""
      );
      setSelectCountries(route.params.allow_countries);
      setPostYearStart(route.params.pose_start.split("T")[0].split("-")[0]);
      setPostMonthStart(route.params.pose_start.split("T")[0].split("-")[1]);
      setPostDateStart(route.params.pose_start.split("T")[0].split("-")[2]);
      setPostYearEnd(route.params.pose_end.split("T")[0].split("-")[0]);
      setPostMonthEnd(route.params.pose_end.split("T")[0].split("-")[1]);
      setPostDateEnd(route.params.pose_end.split("T")[0].split("-")[2]);

      //final
      setFinalDateEnd(route.params.final_end_date.split("T")[0].split("-")[2]);
      setFinalDateStart(
        route.params.final_start_date.split("T")[0].split("-")[2]
      );
      setFinalMonthEnd(route.params.final_end_date.split("T")[0].split("-")[1]);
      setFinalMonthStart(
        route.params.final_start_date.split("T")[0].split("-")[1]
      );
      setFinalYearEnd(route.params.final_end_date.split("T")[0].split("-")[0]);
      setFinalYearStart(
        route.params.final_start_date.split("T")[0].split("-")[0]
      );
      //prelim
      setMailDatePrelim(
        route.params.prelim_mail_date.split("T")[0].split("-")[2]
      );
      setMailMonthPrelim(
        route.params.prelim_mail_date.split("T")[0].split("-")[1]
      );
      setMailYearPrelim(
        route.params.prelim_mail_date.split("T")[0].split("-")[0]
      );
      setMailDateFinal(
        route.params.final_mail_date.split("T")[0].split("-")[2]
      );
      setMailMonthFinal(
        route.params.final_mail_date.split("T")[0].split("-")[1]
      );
      setMailYearFinal(
        route.params.final_mail_date.split("T")[0].split("-")[0]
      );

      setPrelimDateEnd(
        route.params.prelim_end_date.split("T")[0].split("-")[2]
      );
      setPrelimDateStart(
        route.params.prelim_start_date.split("T")[0].split("-")[2]
      );
      setPrelimMonthEnd(
        route.params.prelim_end_date.split("T")[0].split("-")[1]
      );
      setPrelimMonthStart(
        route.params.prelim_start_date.split("T")[0].split("-")[1]
      );
      setPrelimYearEnd(
        route.params.prelim_end_date.split("T")[0].split("-")[0]
      );
      setPrelimYearStart(
        route.params.prelim_start_date.split("T")[0].split("-")[0]
      );
      setLimitAgeYearStart(
        route.params.limit_age_start.split("T")[0].split("-")[0]
      );
      setLimitAgeDateStart(
        route.params.limit_age_start.split("T")[0].split("-")[2]
      );
      setLimitAgeMonthStart(
        route.params.limit_age_start.split("T")[0].split("-")[1]
      );
      setLimitAgeYearEnd(
        route.params.limit_age_end.split("T")[0].split("-")[0]
      );
      setLimitAgeDateEnd(
        route.params.limit_age_end.split("T")[0].split("-")[2]
      );
      setLimitAgeMonthEnd(
        route.params.limit_age_end.split("T")[0].split("-")[1]
      );
      setGenerationIndex((preIndex) =>
        route.params.generation == "Senior"
          ? 0
          : route.params.generation == "Youth"
          ? 1
          : 2
      );
      setStateCompe((val) => ({ ...val, host_id: route.params.host_id }));
      setTime({
        timeHourPrelimStart: route.params.prelim_start_date
          .split("T")[1]
          .split(":")[0],
        timeMinutePrelimStart: route.params.prelim_start_date
          .split("T")[1]
          .split(":")[1],
        timeHourPrelimEnd: route.params.prelim_end_date
          .split("T")[1]
          .split(":")[0],
        timeMinutePrelimEnd: route.params.prelim_end_date
          .split("T")[1]
          .split(":")[1],
        timeHourPrelimSendMail: route.params.prelim_mail_date
          .split("T")[1]
          .split(":")[0],
        timeMinutePrelimSendmail: route.params.prelim_mail_date
          .split("T")[1]
          .split(":")[1],
        timeHourFinalStart: route.params.final_start_date
          .split("T")[1]
          .split(":")[0],
        timeMinuteFinalStart: route.params.final_start_date
          .split("T")[1]
          .split(":")[1],
        timeHourFinalEnd: route.params.final_end_date
          .split("T")[1]
          .split(":")[0],
        timeMinuteFinalEnd: route.params.final_end_date
          .split("T")[1]
          .split(":")[1],
        timeHourFinalSendMail: route.params.final_mail_date
          .split("T")[1]
          .split(":")[0],
        timeMinuteFinalSendmail: route.params.final_mail_date
          .split("T")[1]
          .split(":")[0],
        timeHourPostStart: route.params.pose_start.split("T")[1].split(":")[0],
        timeMinutePostStart: route.params.pose_start
          .split("T")[1]
          .split(":")[1],
        timeHourPostEnd: route.params.pose_end.split("T")[1].split(":")[0],
        timeMinutePostEnd: route.params.pose_end.split("T")[1].split(":")[1],
        timeMinuteLimitAgeStart: route.params.limit_age_start
          .split("T")[1]
          .split(":")[0],
        timeHourLimitAgeStart: route.params.limit_age_start
          .split("T")[1]
          .split(":")[0],
        timeMinuteLimitAgeEnd: route.params.limit_age_end
          .split("T")[1]
          .split(":")[0],
        timeHourLimitAgeEnd: route.params.limit_age_end
          .split("T")[1]
          .split(":")[0],
      });
    }
  }, [token, focus]);

  async function recallgetCountriesEvent() {
    try {
      const response = await apiservice({
        path: "/competitions/opt/components",
        method: "get",
        token: token.token,
      });
      if (response.status == 200) {
        console.log("params >> ", route.params);
        if (route.params != undefined) {
          if (typeof route.params.allow_countries == "string") {
            route.params.allow_countries =
              route.params.allow_countries.split(",");
          }
          if (typeof route.params.events_female == "string") {
            route.params.events_female = route.params.events_female.split(",");
          }
          if (typeof route.params.events_male == "string") {
            route.params.events_male = route.params.events_male.split(",");
          }
        }

        if (response.data.getCountriesComponent != undefined) {
          const Countries = response.data.getCountriesComponent.map((e) => {
            if (route.params != undefined) {
              if (
                route.params.allow_countries.filter(
                  (items) => items == e.country_name
                ).length > 0
              ) {
                return { ...e, select: true };
              } else {
                return { ...e, select: false };
              }
            } else {
              return e;
            }
          });
          let Event = response.data.getEventsComponent.map((e) => {
            return { ...e, select: false };
          });
          let ReEvent = null;
          if (route.params != undefined) {
            ReEvent = Event.map((item, index) => {
              console.log(route.params.events_female);
              setSelectEventFemale(route.params.events_female);
              setSelectEventMale(route.params.events_male);

              if (
                route.params.events_female.filter((e) => e == item.event_name)
                  .length > 0
              ) {
                return { ...item, select: true };
              } else if (
                route.params.events_male.filter((e) => e == item.event_name)
                  .length > 0
              ) {
                return { ...item, select: true };
              } else {
                return item;
              }
            });
            setInformationEvent(response.data !== undefined && ReEvent);
          } else {
            setInformationEvent(response.data !== undefined && Event);
          }
          // setInformationCountry(response.data !== undefined && Countries);
        }
      }
    } catch (error) {
      throw error;
    }
  }

  async function getCountriesEvent() {
    try {
      const response = await apiservice({
        path: "/competitions/opt/components",
        method: "get",
        token: token.token,
      });
      if (response.status == 200) {
        console.log("params >> ", route.params);
        if (route.params != undefined) {
          if (typeof route.params.allow_countries == "string") {
            route.params.allow_countries =
              route.params.allow_countries.split(",");
          }
          if (typeof route.params.events_female == "string") {
            route.params.events_female = route.params.events_female.split(",");
          }
          if (typeof route.params.events_male == "string") {
            route.params.events_male = route.params.events_male.split(",");
          }
        }

        if (response.data.getCountriesComponent != undefined) {
          const Countries = response.data.getCountriesComponent.map((e) => {
            if (route.params != undefined) {
              if (
                route.params.allow_countries.filter(
                  (items) => items == e.country_name
                ).length > 0
              ) {
                return { ...e, select: true };
              } else {
                return { ...e, select: false };
              }
            } else {
              return e;
            }
          });
          let Event = response.data.getEventsComponent.map((e) => {
            return { ...e, select: false };
          });
          let ReEvent = null;
          if (route.params != undefined) {
            ReEvent = Event.map((item, index) => {
              console.log(route.params.events_female);
              setSelectEventFemale(route.params.events_female);
              setSelectEventMale(route.params.events_male);

              if (
                route.params.events_female.filter((e) => e == item.event_name)
                  .length > 0
              ) {
                return { ...item, select: true };
              } else if (
                route.params.events_male.filter((e) => e == item.event_name)
                  .length > 0
              ) {
                return { ...item, select: true };
              } else {
                return item;
              }
            });
            setInformationEvent(response.data !== undefined && ReEvent);
          } else {
            setInformationEvent(response.data !== undefined && Event);
          }
          setInformationCountry(response.data !== undefined && Countries);
        }
      }
    } catch (error) {
      throw error;
    }
  }

  function name(stateCompe, key, year, month, date, hour, minute, time) {
    let bodyState = stateCompe;
    if (month.length == 1) {
      month = "0" + month;
    }
    if (date.length == 1) {
      date = "0" + date;
    } else if (date.length == 3) {
      date = parseInt(date);
    }

    if (time[hour] == null) {
      time[hour] = "00";
    }
    if (time[minute] == null) {
      time[minute] = "00";
    }

    if (time[hour].toString().length == 1) {
      time[hour] = "0" + time[hour];
    }
    if (time[minute].toString().length == 1) {
      time[minute] = "0" + time[minute];
    }

    bodyState[key] =
      year +
      "-" +
      month +
      "-" +
      date +
      "T" +
      `${time[hour]}` +
      ":" +
      `${time[minute]}` +
      ":" +
      "00" +
      ".000Z";
    return bodyState;
  }

  async function onPress() {
    console.log(stateCompe);
    if (stateCompe.competition_name.length == 0) {
      setValidation((val) => ({ ...val, valid1: true }));
      // return;
    }
    if (stateCompe.description.length == 0) {
      setValidation((val) => ({ ...val, valid2: true }));
      // return;
    }
    if (stateCompe.host_id == null) {
      setValidation((val) => ({ ...val, valid3: true }));
      // return;
    }
    if (selectCountries.length == 0) {
      setValidation((val) => ({ ...val, valid4: true }));
      // return;
    }
    if (selectEventFemale.length == 0 && selectEventMale.length == 0) {
      setValidation((val) => ({ ...val, valid5: true }));
      // return;
    }
    if (stateCompe.room_type_request.length == 0) {
      setValidation((val) => ({ ...val, valid6: true }));
      // return;
    }

    if (
      stateCompe.room_type_request.length !== 0 &&
      (selectEventFemale.length !== 0 || selectEventMale.length !== 0) &&
      selectCountries.length !== 0 &&
      stateCompe.host_id !== null &&
      stateCompe.description.length !== 0 &&
      stateCompe.competition_name.length !== 0
    ) {
      let result = name(
        stateCompe,
        "prelim_start_date",
        prelimYearStart,
        prelimMonthStart,
        prelimDateStart,
        "timeHourPrelimStart",
        "timeMinutePrelimStart",
        time
      );
      let result2 = name(
        stateCompe,
        "prelim_end_date",
        prelimYearEnd,
        prelimMonthEnd,
        prelimDateEnd,
        "timeHourPrelimEnd",
        "timeMinutePrelimEnd",
        time
      );
      let result3 = name(
        stateCompe,
        "final_start_date",
        finalYearStart,
        finalMonthStart,
        finalDateStart,
        "timeHourFinalStart",
        "timeMinuteFinalStart",
        time
      );
      let result4 = name(
        stateCompe,
        "final_end_date",
        finalYearEnd,
        finalMonthEnd,
        finalDateEnd,
        "timeHourFinalEnd",
        "timeMinuteFinalEnd",
        time
      );
      let result5 = name(
        stateCompe,
        "prelim_mail_date",
        mailYearPrelim,
        mailMonthPrelim,
        mailDatePrelim,
        "timeHourPrelimSendMail",
        "timeMinutePrelimSendmail",
        time
      );
      let result6 = name(
        stateCompe,
        "final_mail_date",
        mailYearFinal,
        mailMonthFinal,
        mailDateFinal,
        "timeHourFinalSendMail",
        "timeMinuteFinalSendmail",
        time
      );
      let result7 = name(
        stateCompe,
        "limit_age_start",
        limitAgeYearStart,
        limitAgeMonthStart,
        limitAgeDateStart,
        "timeHourLimitAgeStart",
        "timeMinuteLimitAgeStart",
        time
      );
      let result8 = name(
        stateCompe,
        "limit_age_end",
        limitAgeYearEnd,
        limitAgeMonthEnd,
        limitAgeDateEnd,
        "timeHourLimitAgeEnd",
        "timeMinuteLimitAgeEnd",
        time
      );
      let result9 = name(
        stateCompe,
        "pose_start",
        postYearStart,
        postMonthStart,
        postDateStart,
        "timeHourPostStart",
        "timeMinutePostStart",
        time
      );
      let result10 = name(
        stateCompe,
        "pose_end",
        postYearEnd,
        postMonthEnd,
        postDateEnd,
        "timeHourPostEnd",
        "timeMinutePostEnd",
        time
      );

      if (route.params != undefined) {
        let sendody = {
          ...result10,
          host_id: parseInt(stateCompe.host_id),
          description: descomp,
          competition_name: nameCom,
          competition_id: parseInt(route.params.competition_id),
          events_female: selectEventFemale,
          events_male: selectEventMale,
          allow_countries: selectCountries,
          image: route.params.image_url,
          generation:
            generationIndex == 0
              ? "Senior"
              : generationIndex == 1
              ? "Youth"
              : "Junior",
          new_image: imageName.includes("base64") ? imageName : null,
        };
        const create = await authActionPutCompe(sendody, token.token);
        if (create) {
          navigation.navigate("Competition");
        }
      } else {
        let sendody = {
          ...result10,
          host_id: parseInt(stateCompe.host_id),
          description: descomp,
          competition_name: nameCom,
          events_female: selectEventFemale,
          events_male: selectEventMale,
          allow_countries: selectCountries,
          image: imageName,
        };
        const create = await authActionCreateCompe(sendody, token.token);
        if (create) {
          navigation.navigate("Competition");
        }
      }
    }
  }

  function limit(val, max) {
    if (val.length === 1 && val[0] > max[0]) {
      val = "0" + val;
    }
    if (val.length === 2) {
      if (Number(val) === 0) {
        val = "00";
      } else if (val > max) {
        val = max;
      }
    }
    return val;
  }

  function hour(val) {
    let hour = limit(val.substring(0, 2), "23");
    return hour;
  }

  function minute(val) {
    let minute = limit(val.substring(0, 2), "59");
    return minute;
  }

  return (
    <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={styles.viewModal}>
          <View style={styles.viewDetailModal}>
            <TouchableOpacity
              onPress={() => {
                setModalVisible(!modalVisible);
              }}
              style={{ alignSelf: "flex-end", paddingRight: 15 }}
            >
              <Text>X</Text>
            </TouchableOpacity>
            <View style={{ alignSelf: "center" }}>
              <Text style={styles.textSubject}>
                Event {AddEventMale.event_gender} name
              </Text>
              <TextInput
                onChangeText={(text) =>
                  setAddEventMale({ ...AddEventMale, event_name: text })
                }
                defaultValue={AddEventMale.event_name}
                style={styles.textInputNameEventModal}
              />
            </View>
            <TouchableOpacity
              onPress={EventMale}
              style={{
                width: width * 0.1,
                height: 50,
                backgroundColor: "#2B6AB1",
                alignSelf: "center",
                justifyContent: "center",
                borderRadius: 10,
                marginTop: 40,
              }}
            >
              <Text
                style={{
                  alignSelf: "center",
                  fontSize: 18,
                  fontFamily: "Prompt",
                  color: "#FFFFFF",
                }}
              >
                SAVE
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
      <View
        style={{
          width: "100%",
          flexDirection: width >= 1280 ? "row" : "column",
        }}
      >
        <View
          style={
            (width >= 1600 && styles.viewCreate) || width >= 1280
              ? styles.viewCreateRespons
              : stylesResponsive.viewCreate
          }
        >
          <Text style={styles.textSubject}>IMAGE</Text>
          <TouchableOpacity onPress={pickImage} style={styles.buttonPickImg}>
            <View style={styles.viewPickImg}>
              <Text style={styles.textUpPhoto}>Upload</Text>
            </View>
            <Text style={styles.textSelectPhoto}>select your photo</Text>
          </TouchableOpacity>
          <Image
            resizeMode={"contain"}
            style={{
              width: width >= 1280 ? 300 : 120,
              height: width >= 1280 ? 100 : 80,
              borderRadius: 10,
              marginTop: 10,
            }}
            source={{ uri: imageName }}
          />
          <Text style={styles.textSubject}>NAME</Text>
          <TextInput
            defaultValue={nameCom}
            onChangeText={(text) => {
              setStateCompe((val) => ({ ...val, competition_name: text }));
              setNameCom(text);
            }}
            style={[
              styles.textInpuName,
              { borderBottomColor: validation.valid1 ? "#ff0000" : "#2B6AB1" },
            ]}
          />
          <Text style={styles.textSubject}>CONDITION</Text>
          <View
            style={[
              styles.viewCkEditor,
              { borderBottomColor: validation.valid2 ? "#ff0000" : "#2B6AB1" },
            ]}
          >
            <CKEditor
              editor={ClassicEditor}
              data={route.params != undefined ? route.params.description : ""}
              onReady={(editor) => {
                // You can store the "editor" and use when it is needed.
                // console.log("Editor is ready to use!", editor);
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                // console.log("Change>>>", { event, editor, data });
                setDesCom(data);
                setStateCompe((val) => ({ ...val, description: data }));
              }}
              onBlur={(event, editor) => {
                // console.log("Blur.", editor);
              }}
              onFocus={(event, editor) => {
                // console.log("Focus.", editor);
              }}
            />
          </View>

          <View
            style={{
              flexDirection: width >= 1280 ? "row" : "column",
              justifyContent: width >= 1280 ? "space-between" : "flex-start",
            }}
          >
            <View
              style={{
                width: width >= 1280 ? width * 0.17 : width * 0.78,
              }}
            >
              <Text style={styles.textSubject}>PRELIMINARY DATE</Text>
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => setShowCalendarPrelimStart(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {prelimYearStart +
                      "-" +
                      prelimMonthStart +
                      "-" +
                      prelimDateStart}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    maxLength={2}
                    format={hour}
                    value={time.timeHourPrelimStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourPrelimStart: hour(newText) });
                    }}
                    maxLength={2}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />

                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    maxLength={2}
                    format={minute}
                    value={time.timeMinutePrelimStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({
                        ...time,
                        timeMinutePrelimStart: minute(newText),
                      });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarPrelimStart}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarPrelimStart(false)}
                defaultDate={
                  prelimYearStart +
                  "-" +
                  prelimMonthStart +
                  "-" +
                  prelimDateStart
                }
                onDatePicked={(res) => {
                  setStateCompe((val) => ({
                    ...val,
                    prelim_start_date:
                      res.year + "-" + res.month + "-" + res.date,
                  }));
                  setPrelimYearStart(res.year);
                  setPrelimMonthStart(res.month);
                  setPrelimDateStart(res.date);
                }}
              />
              <Feather
                name="minus"
                size={14}
                color={"#2B6AB1"}
                style={{ alignSelf: "center", marginTop: 7 }}
              />
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => setShowCalendarPrelimEnd(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {prelimYearEnd + "-" + prelimMonthEnd + "-" + prelimDateEnd}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    format={hour}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourPrelimEnd: hour(newText) });
                    }}
                    maxLength={2}
                    value={time.timeHourPrelimEnd}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    format={minute}
                    maxLength={2}
                    value={time.timeMinutePrelimEnd}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({
                        ...time,
                        timeMinutePrelimEnd: minute(newText),
                      });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarPrelimEnd}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarPrelimEnd(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setPrelimYearEnd(res.year);
                  setPrelimMonthEnd(res.month);
                  setPrelimDateEnd(res.date);
                }}
              />
              {width < 1280 && (
                <View
                  style={{
                    width: width * 0.7,
                  }}
                >
                  <Text style={styles.textSubject}>SEND MAIL DATE</Text>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={() => setShowCalendarMailPrelim(true)}
                      style={[
                        styles.buttonSelectCalendar,
                        { width: width * 0.35 },
                      ]}
                    >
                      <Text style={styles.textDate}>
                        {mailYearPrelim +
                          "-" +
                          mailMonthPrelim +
                          "-" +
                          mailDatePrelim}
                      </Text>
                      <FontAwesome
                        name="caret-down"
                        size={24}
                        color={"#2B6AB1"}
                        style={styles.iconSelectDate}
                      />
                    </TouchableOpacity>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: 18,
                      }}
                    >
                      <TextInput
                        format={hour}
                        maxLength={2}
                        value={time.timeHourPrelimSendMail}
                        onChangeText={(text) => {
                          let newText = "";
                          let numbers = "0123456789";

                          for (var i = 0; i < text.length; i++) {
                            if (numbers.indexOf(text[i]) > -1) {
                              newText = newText + text[i];
                            } else {
                              // your call back function
                              alert("please enter numbers only");
                            }
                          }
                          setTime({
                            ...time,
                            timeHourPrelimSendMail: hour(newText),
                          });
                        }}
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 5,
                          backgroundColor: "#FFFFFF",
                          borderWidth: 1,
                          borderColor: "#7F9DBF",
                          textAlign: "center",
                          color: "#2B6AB1",
                          fontSize: 12,
                          fontFamily: "Prompt",
                          marginTop: 7,
                        }}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        format={minute}
                        maxLength={2}
                        value={time.timeMinutePrelimSendmail}
                        onChangeText={(text) => {
                          let newText = "";
                          let numbers = "0123456789";

                          for (var i = 0; i < text.length; i++) {
                            if (numbers.indexOf(text[i]) > -1) {
                              newText = newText + text[i];
                            } else {
                              // your call back function
                              alert("please enter numbers only");
                            }
                          }
                          setTime({
                            ...time,
                            timeMinutePrelimSendmail: minute(newText),
                          });
                        }}
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 5,
                          backgroundColor: "#FFFFFF",
                          borderWidth: 1,
                          borderColor: "#7F9DBF",
                          textAlign: "center",
                          color: "#2B6AB1",
                          fontSize: 12,
                          fontFamily: "Prompt",
                          marginTop: 7,
                        }}
                      />
                    </View>
                  </View>
                  <CalendarPicker
                    locale="en-us"
                    show={showCalendarMailPrelim}
                    allowPageClickToClose={true}
                    onClose={() => setShowCalendarMailPrelim(false)}
                    defaultDate={year + "-" + month + "-" + date}
                    onDatePicked={(res) => {
                      setMailYearPrelim(res.year);
                      setMailMonthPrelim(res.month);
                      setMailDatePrelim(res.date);
                    }}
                  />
                </View>
              )}
              <Text style={styles.textSubject}>FINAL DATE</Text>
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => setShowCalendarFinalStart(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {finalYearStart +
                      "-" +
                      finalMonthStart +
                      "-" +
                      finalDateStart}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    format={hour}
                    maxLength={2}
                    value={time.timeHourFinalStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourFinalStart: hour(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    format={minute}
                    maxLength={2}
                    value={time.timeMinuteFinalStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({
                        ...time,
                        timeMinuteFinalStart: minute(newText),
                      });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarFinalStart}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarFinalStart(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setFinalYearStart(res.year);
                  setFinalMonthStart(res.month);
                  setFinalDateStart(res.date);
                }}
              />
              <Feather
                name="minus"
                size={14}
                color={"#2B6AB1"}
                style={{ alignSelf: "center", marginTop: 7 }}
              />
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => setShowCalendarFinalEnd(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {finalYearEnd + "-" + finalMonthEnd + "-" + finalDateEnd}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    format={hour}
                    maxLength={2}
                    value={time.timeHourFinalEnd}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourFinalEnd: hour(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    format={minute}
                    maxLength={2}
                    value={time.timeMinuteFinalEnd}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeMinuteFinalEnd: minute(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarFinalEnd}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarFinalEnd(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setFinalYearEnd(res.year);
                  setFinalMonthEnd(res.month);
                  setFinalDateEnd(res.date);
                }}
              />
              {width < 1280 && (
                <View
                  style={{
                    width: width * 0.7,
                  }}
                >
                  <Text style={[styles.textSubject]}>SEND MAIL DATE</Text>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={() => setShowCalendarMailFinal(true)}
                      style={[
                        styles.buttonSelectCalendar,
                        { width: width * 0.35 },
                      ]}
                    >
                      <Text style={styles.textDate}>
                        {mailYearFinal +
                          "-" +
                          mailMonthFinal +
                          "-" +
                          mailDateFinal}
                      </Text>
                      <FontAwesome
                        name="caret-down"
                        size={24}
                        color={"#2B6AB1"}
                        style={styles.iconSelectDate}
                      />
                    </TouchableOpacity>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginLeft: 18,
                      }}
                    >
                      <TextInput
                        format={hour}
                        maxLength={2}
                        value={time.timeHourFinalSendMail}
                        onChangeText={(text) => {
                          let newText = "";
                          let numbers = "0123456789";

                          for (var i = 0; i < text.length; i++) {
                            if (numbers.indexOf(text[i]) > -1) {
                              newText = newText + text[i];
                            } else {
                              // your call back function
                              alert("please enter numbers only");
                            }
                          }
                          setTime({
                            ...time,
                            timeHourFinalSendMail: hour(newText),
                          });
                        }}
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 5,
                          backgroundColor: "#FFFFFF",
                          borderWidth: 1,
                          borderColor: "#7F9DBF",
                          textAlign: "center",
                          color: "#2B6AB1",
                          fontSize: 12,
                          fontFamily: "Prompt",
                          marginTop: 7,
                        }}
                      />
                      <Text style={styles.textStatistic}>:</Text>
                      <TextInput
                        format={minute}
                        maxLength={2}
                        value={time.timeMinuteFinalSendmail}
                        onChangeText={(text) => {
                          let newText = "";
                          let numbers = "0123456789";

                          for (var i = 0; i < text.length; i++) {
                            if (numbers.indexOf(text[i]) > -1) {
                              newText = newText + text[i];
                            } else {
                              // your call back function
                              alert("please enter numbers only");
                            }
                          }
                          setTime({
                            ...time,
                            timeMinuteFinalSendmail: minute(newText),
                          });
                        }}
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 5,
                          backgroundColor: "#FFFFFF",
                          borderWidth: 1,
                          borderColor: "#7F9DBF",
                          textAlign: "center",
                          color: "#2B6AB1",
                          fontSize: 12,
                          fontFamily: "Prompt",
                          marginTop: 7,
                        }}
                      />
                    </View>
                  </View>
                  <CalendarPicker
                    locale="en-us"
                    show={showCalendarMailFinal}
                    allowPageClickToClose={true}
                    onClose={() => setShowCalendarMailFinal(false)}
                    defaultDate={year + "-" + month + "-" + date}
                    onDatePicked={(res) => {
                      setMailYearFinal(res.year);
                      setMailMonthFinal(res.month);
                      setMailDateFinal(res.date);
                    }}
                  />
                </View>
              )}
              <View
                style={{
                  width: width >= 1280 ? width * 0.1 : width * 0.35,
                }}
              >
                <Text style={[styles.textSubject, { marginBottom: 7 }]}>
                  HOST
                </Text>
                {informationCountry.length > 0 && (
                  <Dropdown
                    style={{
                      borderColor: validation.valid3 ? "#ff0000" : "#2B6AB1",
                    }}
                    value={stateCompe.host_id}
                    setValue={(e) => {
                      if (e != null) {
                        setStateCompe((val) => ({ ...val, host_id: e }));
                        let item = informationCountry.filter(
                          (val, i) => val.Association[0].association_id == e
                        )[0];
                        if (
                          selectCountries.filter((e) => e == item.country_name)
                            .length == 0
                        ) {
                          setSelectCountries((val) =>
                            val.concat(item.country_name)
                          );

                          let selecount = informationCountry;
                          const i = selecount.findIndex((e) => {
                            return e.country_id === item.country_id;
                          });
                          if (i > -1) {
                            selecount[i].select = !selecount[i].select;
                          }
                          const Check = selecount.every(
                            (e) => e.select === true
                          );
                          Check ? setCheckBoxAll(true) : setCheckBoxAll(false);
                          setInformationCountry(selecount);
                          setkeyindex(Math.floor(Math.random() * 100 + 1));
                        }
                        // setSelectCountries
                      }
                    }}
                    Host
                    informationCountry={informationCountry}
                  />
                )}
              </View>
              <Text style={styles.textSubject}>GENERATION</Text>
              <View style={{ flexDirection: "row", marginTop: 7 }}>
                {generationList.map((data, index) => (
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <TouchableOpacity
                      key={data}
                      style={[
                        styles.buttonCheckbox,
                        {
                          marginLeft: index > 0 && 22,
                          backgroundColor:
                            index === generationIndex ? "#2B6AB1" : "#FFFFFF",
                        },
                      ]}
                      onPress={generationChangeHandler.bind(this, index)}
                    ></TouchableOpacity>
                    <Text style={styles.textDetail}>{data}</Text>
                  </View>
                ))}
              </View>
              <Text
                style={[
                  styles.textSubject,
                  { color: generationIndex == 0 ? "#B9B9B9" : "#2B6AB1" },
                ]}
              >
                LIMIT AGE
              </Text>
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TouchableOpacity
                  disabled={generationIndex == 0 ? true : false}
                  onPress={() => setShowCalendarLimitAgeStart(true)}
                  style={[
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar,
                    {
                      borderColor: generationIndex == 0 ? "#B9B9B9" : "#7F9DBF",
                    },
                  ]}
                >
                  <Text style={styles.textDate}>
                    {generationIndex == 0
                      ? ""
                      : limitAgeYearStart +
                        "-" +
                        limitAgeMonthStart +
                        "-" +
                        limitAgeDateStart}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={generationIndex == 0 ? "#B9B9B9" : "#2B6AB1"}
                    style={[
                      styles.iconSelectDate,
                      {
                        borderLeftColor:
                          generationIndex == 0 ? "#B9B9B9" : "#2B6AB1",
                      },
                    ]}
                  />
                </TouchableOpacity>
                <Feather
                  name="minus"
                  size={14}
                  color={generationIndex == 0 ? "#B9B9B9" : "#2B6AB1"}
                  style={{ marginHorizontal: 5, marginTop: 10 }}
                />
                <TouchableOpacity
                  disabled={generationIndex == 0 ? true : false}
                  onPress={() => setShowCalendarLimitAgeEnd(true)}
                  style={[
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar,
                    {
                      borderColor: generationIndex == 0 ? "#B9B9B9" : "#7F9DBF",
                    },
                  ]}
                >
                  <Text style={styles.textDate}>
                    {generationIndex == 0
                      ? ""
                      : limitAgeYearEnd +
                        "-" +
                        limitAgeMonthEnd +
                        "-" +
                        limitAgeDateEnd}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={generationIndex == 0 ? "#B9B9B9" : "#2B6AB1"}
                    style={[
                      styles.iconSelectDate,
                      {
                        borderLeftColor:
                          generationIndex == 0 ? "#B9B9B9" : "#2B6AB1",
                      },
                    ]}
                  />
                </TouchableOpacity>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarLimitAgeStart}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarLimitAgeStart(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setLimitAgeYearStart(res.year);
                  setLimitAgeMonthStart(res.month);
                  setLimitAgeDateStart(res.date);
                }}
              />
              <CalendarPicker
                locale="en-us"
                show={showCalendarLimitAgeEnd}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarLimitAgeEnd(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setLimitAgeYearEnd(res.year);
                  setLimitAgeMonthEnd(res.month);
                  setLimitAgeDateEnd(res.date);
                }}
              />
              <Text style={styles.textSubject}>POST START</Text>
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => setShowCalendarPostStart(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {postYearStart + "-" + postMonthStart + "-" + postDateStart}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    format={hour}
                    maxLength={2}
                    value={time.timeHourPostStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourPostStart: hour(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    format={minute}
                    maxLength={2}
                    value={time.timeMinutePostStart}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({
                        ...time,
                        timeMinutePostStart: minute(newText),
                      });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarPostStart}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarPostStart(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setPostYearStart(res.year);
                  setPostMonthStart(res.month);
                  setPostDateStart(res.date);
                }}
              />
              <Text style={styles.textSubject}>POST END</Text>
              <View
                style={{
                  flexDirection: "row",
                  marginBottom: width < 1280 && 40,
                }}
              >
                <TouchableOpacity
                  onPress={() => setShowCalendarPostEnd(true)}
                  style={
                    width >= 1280
                      ? styles.buttonSelectCalendar
                      : stylesResponsive.buttonSelectCalendar
                  }
                >
                  <Text style={styles.textDate}>
                    {postYearEnd + "-" + postMonthEnd + "-" + postDateEnd}
                  </Text>
                  <FontAwesome
                    name="caret-down"
                    size={24}
                    color={"#2B6AB1"}
                    style={styles.iconSelectDate}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: 18,
                  }}
                >
                  <TextInput
                    format={hour}
                    maxLength={2}
                    value={time.timeHourPostEnd}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeHourPostEnd: hour(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                  <Text style={styles.textStatistic}>:</Text>
                  <TextInput
                    format={minute}
                    maxLength={2}
                    value={time.timeMinutePostEnd}
                    onChangeText={(text) => {
                      let newText = "";
                      let numbers = "0123456789";

                      for (var i = 0; i < text.length; i++) {
                        if (numbers.indexOf(text[i]) > -1) {
                          newText = newText + text[i];
                        } else {
                          // your call back function
                          alert("please enter numbers only");
                        }
                      }
                      setTime({ ...time, timeMinutePostEnd: minute(newText) });
                    }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 5,
                      backgroundColor: "#FFFFFF",
                      borderWidth: 1,
                      borderColor: "#7F9DBF",
                      textAlign: "center",
                      color: "#2B6AB1",
                      fontSize: 12,
                      fontFamily: "Prompt",
                      marginTop: 7,
                    }}
                  />
                </View>
              </View>
              <CalendarPicker
                locale="en-us"
                show={showCalendarPostEnd}
                allowPageClickToClose={true}
                onClose={() => setShowCalendarPostEnd(false)}
                defaultDate={year + "-" + month + "-" + date}
                onDatePicked={(res) => {
                  setPostYearEnd(res.year);
                  setPostMonthEnd(res.month);
                  setPostDateEnd(res.date);
                }}
              />
              {width >= 1280 && (
                <TouchableOpacity
                  onPress={onPress}
                  style={[
                    styles.ButtonSave,
                    {
                      width: (textButtonSend && 194) || (textButtonSave && 66),
                    },
                  ]}
                >
                  <Text style={styles.textSave}>
                    {textButtonSend && "create and send mail"}
                    {textButtonSave && "SAVE"}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
            {width >= 1280 && (
              <View
                style={{
                  width: width * 0.17,
                }}
              >
                <Text style={styles.textSubject}>SEND MAIL DATE</Text>
                <View style={{ flexDirection: "row" }}>
                  <TouchableOpacity
                    onPress={() => setShowCalendarMailPrelim(true)}
                    style={styles.buttonSelectCalendar}
                  >
                    <Text style={styles.textDate}>
                      {mailYearPrelim +
                        "-" +
                        mailMonthPrelim +
                        "-" +
                        mailDatePrelim}
                    </Text>
                    <FontAwesome
                      name="caret-down"
                      size={24}
                      color={"#2B6AB1"}
                      style={styles.iconSelectDate}
                    />
                  </TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginLeft: 18,
                    }}
                  >
                    <TextInput
                      format={hour}
                      maxLength={2}
                      value={time.timeHourPrelimSendMail}
                      onChangeText={(text) => {
                        let newText = "";
                        let numbers = "0123456789";

                        for (var i = 0; i < text.length; i++) {
                          if (numbers.indexOf(text[i]) > -1) {
                            newText = newText + text[i];
                          } else {
                            // your call back function
                            alert("please enter numbers only");
                          }
                        }
                        setTime({
                          ...time,
                          timeHourPrelimSendMail: hour(newText),
                        });
                      }}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 5,
                        backgroundColor: "#FFFFFF",
                        borderWidth: 1,
                        borderColor: "#7F9DBF",
                        textAlign: "center",
                        color: "#2B6AB1",
                        fontSize: 12,
                        fontFamily: "Prompt",
                        marginTop: 7,
                      }}
                    />
                    <Text style={styles.textStatistic}>:</Text>
                    <TextInput
                      format={minute}
                      maxLength={2}
                      value={time.timeMinutePrelimSendmail}
                      onChangeText={(text) => {
                        let newText = "";
                        let numbers = "0123456789";

                        for (var i = 0; i < text.length; i++) {
                          if (numbers.indexOf(text[i]) > -1) {
                            newText = newText + text[i];
                          } else {
                            // your call back function
                            alert("please enter numbers only");
                          }
                        }
                        setTime({
                          ...time,
                          timeMinutePrelimSendmail: minute(newText),
                        });
                      }}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 5,
                        backgroundColor: "#FFFFFF",
                        borderWidth: 1,
                        borderColor: "#7F9DBF",
                        textAlign: "center",
                        color: "#2B6AB1",
                        fontSize: 12,
                        fontFamily: "Prompt",
                        marginTop: 7,
                      }}
                    />
                  </View>
                </View>
                <CalendarPicker
                  locale="en-us"
                  show={showCalendarMailPrelim}
                  allowPageClickToClose={true}
                  onClose={() => setShowCalendarMailPrelim(false)}
                  defaultDate={year + "-" + month + "-" + date}
                  onDatePicked={(res) => {
                    setMailYearPrelim(res.year);
                    setMailMonthPrelim(res.month);
                    setMailDatePrelim(res.date);
                  }}
                />
                <Text
                  style={[styles.textSubject, { marginTop: height * 0.08 }]}
                >
                  SEND MAIL DATE
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <TouchableOpacity
                    onPress={() => setShowCalendarMailFinal(true)}
                    style={styles.buttonSelectCalendar}
                  >
                    <Text style={styles.textDate}>
                      {mailYearFinal +
                        "-" +
                        mailMonthFinal +
                        "-" +
                        mailDateFinal}
                    </Text>
                    <FontAwesome
                      name="caret-down"
                      size={24}
                      color={"#2B6AB1"}
                      style={styles.iconSelectDate}
                    />
                  </TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginLeft: 18,
                    }}
                  >
                    <TextInput
                      format={hour}
                      maxLength={2}
                      value={time.timeHourFinalSendMail}
                      onChangeText={(text) => {
                        let newText = "";
                        let numbers = "0123456789";

                        for (var i = 0; i < text.length; i++) {
                          if (numbers.indexOf(text[i]) > -1) {
                            newText = newText + text[i];
                          } else {
                            // your call back function
                            alert("please enter numbers only");
                          }
                        }
                        setTime({
                          ...time,
                          timeHourFinalSendMail: hour(newText),
                        });
                      }}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 5,
                        backgroundColor: "#FFFFFF",
                        borderWidth: 1,
                        borderColor: "#7F9DBF",
                        textAlign: "center",
                        color: "#2B6AB1",
                        fontSize: 12,
                        fontFamily: "Prompt",
                        marginTop: 7,
                      }}
                    />
                    <Text style={styles.textStatistic}>:</Text>
                    <TextInput
                      format={minute}
                      maxLength={2}
                      value={time.timeMinuteFinalSendmail}
                      onChangeText={(text) => {
                        let newText = "";
                        let numbers = "0123456789";

                        for (var i = 0; i < text.length; i++) {
                          if (numbers.indexOf(text[i]) > -1) {
                            newText = newText + text[i];
                          } else {
                            // your call back function
                            alert("please enter numbers only");
                          }
                        }
                        setTime({
                          ...time,
                          timeMinuteFinalSendmail: minute(newText),
                        });
                      }}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 5,
                        backgroundColor: "#FFFFFF",
                        borderWidth: 1,
                        borderColor: "#7F9DBF",
                        textAlign: "center",
                        color: "#2B6AB1",
                        fontSize: 12,
                        fontFamily: "Prompt",
                        marginTop: 7,
                      }}
                    />
                  </View>
                </View>
                <CalendarPicker
                  locale="en-us"
                  show={showCalendarMailFinal}
                  allowPageClickToClose={true}
                  onClose={() => setShowCalendarMailFinal(false)}
                  defaultDate={year + "-" + month + "-" + date}
                  onDatePicked={(res) => {
                    setMailYearFinal(res.year);
                    setMailMonthFinal(res.month);
                    setMailDateFinal(res.date);
                  }}
                />
              </View>
            )}
          </View>
        </View>
        <View
          style={
            (width < 1280 && stylesResponsive.checkbox) || width < 1600
              ? styles.checkboxRespons
              : styles.checkbox
          }
        >
          <Text
            style={[
              styles.textSubject,
              { alignSelf: "center", marginBottom: 10 },
            ]}
          >
            COUNTRIES
          </Text>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <TouchableOpacity
              onPress={() => {
                setSelectCountries([]);
                let index = informationCountry;
                informationCountry.map((res, i) => {
                  if (
                    selectCountries.length == 1 ||
                    selectCountries.length == 0
                  ) {
                    index[i].select = true;
                    setSelectCountries((val) =>
                      val.concat(index[i].country_name)
                    );
                  } else {
                    if (
                      index[i].Association[0].association_id ==
                      stateCompe.host_id
                    ) {
                      index[i].select = true;
                      setSelectCountries((val) =>
                        val.concat(index[i].country_name)
                      );
                    } else {
                      index[i].select = false;
                    }
                  }
                  setCheckBoxAll(!checkboxAll);
                });
                setInformationCountry(index);
                setkeyindex(Math.floor(Math.random() * 100 + 1));
              }}
              style={[
                styles.buttonCheckbox,
                {
                  backgroundColor:
                    informationCountry.length ==
                    informationCountry.filter((item) => item.select).length
                      ? "#2B6AB1"
                      : "#FFFFFF",
                  borderColor: validation.valid4 ? "#ff0000" : "#2B6AB1",
                },
              ]}
            ></TouchableOpacity>
            <Text style={styles.textDetail}>SELECT ALL</Text>
          </View>

          <FlatList
            data={informationCountry}
            numColumns={width >= 1280 ? 3 : 1}
            extraData={stateCompe}
            scrollEnabled={width < 1280 ? true : false}
            keyExtractor={(item) => item.country_id}
            key={keyindex}
            renderItem={({ index, item }) => {
              return (
                <View style={styles.viewCountry}>
                  <TouchableOpacity
                    onPress={() => {
                      console.log(item.Association[0].association_id);
                      console.log(stateCompe.host_id);

                      if (
                        item.Association[0].association_id != stateCompe.host_id
                      ) {
                        if (!item.select) {
                          setSelectCountries((val) =>
                            val.concat(item.country_name)
                          );
                        } else {
                          let Arr = selectCountries.filter(
                            (i) => i !== item.country_name
                          );
                          setSelectCountries(Arr);
                        }
                        let selecount = informationCountry;
                        const i = selecount.findIndex((e) => {
                          return e.country_id === item.country_id;
                        });
                        if (i > -1) {
                          selecount[i].select = !selecount[i].select;
                        }
                        const Check = selecount.every((e) => e.select === true);
                        Check ? setCheckBoxAll(true) : setCheckBoxAll(false);
                        setInformationCountry(selecount);
                        setkeyindex(Math.floor(Math.random() * 100 + 1));
                      }
                    }}
                    style={[
                      styles.buttonCheckbox,
                      {
                        backgroundColor: item.select
                          ? item.Association[0].association_id ==
                            stateCompe.host_id
                            ? "#00C70C"
                            : "#2B6AB1"
                          : "#FFFFFF",
                        borderColor: validation.valid4 ? "#ff0000" : "#2B6AB1",
                      },
                    ]}
                  />
                  <Text style={styles.textDetail}>{item.country_name}</Text>
                </View>
              );
            }}
          />
          <Text
            style={[
              styles.textSubject,
              {
                marginTop: height * 0.05,
                alignSelf: "center",
                color: validation.valid4 ? "#ff0000" : "#2B6AB1",
              },
            ]}
          >
            EVENTS
          </Text>
          {width >= 1600 && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: width * 0.22,
                alignSelf: "center",
              }}
            >
              <Text style={styles.textSubject}>MALE</Text>
              <Text style={styles.textSubject}>FEMALE</Text>
            </View>
          )}
          {width < 1280 && <Text style={styles.textSubject}>MALE</Text>}
          <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
            <View
              style={{
                width: width >= 1280 ? width * 0.17 : width * 0.9,
              }}
            >
              {width >= 1280 && width < 1600 && (
                <Text style={[styles.textSubject, { marginLeft: 35 }]}>
                  MALE
                </Text>
              )}
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TouchableOpacity
                  onPress={() => {
                    let index = informationEvent;
                    // console.log(
                    //   informationEvent.filter(
                    //     (item) => item.event_gender == "Male"
                    //   )
                    // );
                    informationEvent.map((res, i) => {
                      if (res.event_gender == "Male") {
                        if (selectEventMale.length == 0) {
                          index[i].select = true;
                          setSelectEventMale((val) =>
                            val.concat(res.event_name)
                          );
                          setStateCompe((val) => ({
                            ...val,
                            events_male: stateCompe.events_male.concat(
                              res.event_name
                            ),
                          }));
                        } else {
                          index[i].select = false;
                          setSelectEventMale([]);
                          setStateCompe((val) => ({ ...val, events_male: [] }));
                        }
                        setCheckBoxAllMale(!checkboxAllMale);
                      }
                    });
                    setInformationEvent(index);
                    setkeyindexMale(Math.floor(Math.random() * 100 + 1));
                    if (stateCompe.events_male.length > 0) {
                      setStateCompe((val) => ({ ...val, events_male: [] }));
                    } else {
                      setStateCompe((val) => ({
                        ...val,
                        events_male: informationEvent
                          .filter((item) => item.event_gender == "Male")
                          .map((item) => item.event_name),
                      }));
                    }
                  }}
                  style={[
                    styles.buttonCheckbox,
                    {
                      backgroundColor:
                        stateCompe.events_male.length ==
                        informationEvent.filter(
                          (item) => item.event_gender == "Male"
                        ).length
                          ? "#2B6AB1"
                          : "#FFFFFF",
                      borderColor: validation.valid5 ? "#ff0000" : "#2B6AB1",
                    },
                  ]}
                ></TouchableOpacity>
                <Text
                  style={[
                    styles.textDetail,
                    { color: validation.valid5 ? "#ff0000" : "#2B6AB1" },
                  ]}
                >
                  SELECT ALL
                </Text>
              </View>
              <FlatList
                data={informationEvent}
                extraData={[stateCompe, validation]}
                numColumns={width >= 1280 && width < 1850 ? 1 : 2}
                scrollEnabled={width < 1280 ? true : false}
                key={keyindexMale}
                renderItem={({ index, item }) => {
                  return (
                    item.event_gender == "Male" && (
                      <View
                        style={
                          width >= 1280
                            ? styles.viewCheckbox
                            : stylesResponsive.viewCheckbox
                        }
                      >
                        <TouchableOpacity
                          onPress={() => {
                            let Event = informationEvent;
                            const i = Event.findIndex((e) => {
                              return e.event_id === item.event_id;
                            });
                            if (i > -1) {
                              Event[i].select = !Event[i].select;
                            }
                            const Check = Event.every((e) => e.select === true);
                            Check
                              ? setCheckBoxAllMale(true)
                              : setCheckBoxAllMale(false);
                            setInformationEvent(Event);
                            setkeyindexMale(
                              Math.floor(Math.random() * 100 + 1)
                            );
                            if (
                              stateCompe.events_male.filter(
                                (e) => e == item.event_name
                              ).length == 0
                            ) {
                              let events_male = stateCompe.events_male;
                              setStateCompe((val) => ({
                                ...val,
                                events_male: events_male.concat(
                                  item.event_name
                                ),
                              }));
                              setSelectEventMale(
                                stateCompe.events_male.concat(item.event_name)
                              );
                            } else {
                              let Arr = stateCompe.events_male.filter(
                                (e) => e !== item.event_name
                              );
                              setSelectEventMale(Arr);
                              setStateCompe((val) => ({
                                ...val,
                                events_male: Arr,
                              }));
                            }
                          }}
                          style={[
                            styles.buttonCheckbox,
                            {
                              backgroundColor:
                                stateCompe.events_male.filter(
                                  (val) => val == item.event_name
                                ).length > 0
                                  ? "#2B6AB1"
                                  : "#FFFFFF",
                              borderColor: validation.valid5
                                ? "#ff0000"
                                : "#2B6AB1",
                            },
                          ]}
                        ></TouchableOpacity>
                        <Text
                          style={[
                            styles.textDetail,
                            {
                              color: validation.valid5 ? "#ff0000" : "#2B6AB1",
                            },
                          ]}
                        >
                          {item.event_gender == "Male" && item.event_name}
                        </Text>
                        {
                          <TouchableOpacity
                            onPress={async () => {
                              console.log(item);
                              const response = await deleteEvent({
                                body: {
                                  event_id: item.event_id,
                                },
                                token: token.token,
                              });
                              if (response) {
                                recallgetCountriesEvent();
                              }
                            }}
                            style={{
                              width: 20,
                              height: 20,
                              borderRadius: 10,
                              backgroundColor: "#ff0000",
                              alignItems: "center",
                              marginLeft: 10,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Prompt",
                                color: "#fff",
                              }}
                            >
                              -
                            </Text>
                          </TouchableOpacity>
                        }
                      </View>
                    )
                  );
                }}
              />
              <View style={{ flexDirection: "row", marginTop: 20 }}>
                <TouchableOpacity
                  onPress={() => {
                    setAddEventMale({
                      ...AddEventMale,
                      event_gender: "Male",
                    });
                    setModalVisible(true);
                  }}
                  style={styles.viewAddItem}
                >
                  <View style={[[styles.buttonCheckbox, styles.buttonAction]]}>
                    <Entypo name="plus" size={22} color="#2B69B1" />
                  </View>
                  <Text style={styles.textDetail}>ADD EVENT</Text>
                </TouchableOpacity>
                {/* <TouchableOpacity
                  onPress={() => {
                    setDeleteM((val) => !val);
                  }}
                  style={[styles.viewAddItem, { marginLeft: 20 }]}
                >
                  <View style={[styles.buttonCheckbox, styles.buttonAction]}>
                    <Entypo name="minus" size={22} color="#2B69B1" />
                  </View>
                  <Text style={styles.textDetail}>DELETE EVENT</Text>
                </TouchableOpacity> */}
              </View>
            </View>

            {width < 1280 && <Text style={styles.textSubject}>FEMALE</Text>}
            <View
              style={{
                width: width >= 1280 ? width * 0.17 : width * 0.9,
                marginLeft: width >= 1280 ? 40 : 0,
              }}
            >
              {width >= 1280 && width < 1600 && (
                <Text style={[styles.textSubject, { marginLeft: 35 }]}>
                  FEMALE
                </Text>
              )}
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <TouchableOpacity
                  onPress={() => {
                    let index = informationEvent;
                    informationEvent.map((res, i) => {
                      if (
                        selectEventFemale.length == 0 &&
                        res.event_gender == "Female"
                      ) {
                        index[i].select = true;
                        setSelectEventFemale((val) =>
                          val.concat(res.event_name)
                        );
                      } else if (
                        selectEventFemale.length !== 0 &&
                        res.event_gender == "Female"
                      ) {
                        index[i].select = false;
                        setSelectEventFemale([]);
                      }
                    });
                    setCheckBoxAllFemale(!checkboxAllFemale);
                    setInformationEvent(index);
                    setkeyindexFemale(Math.floor(Math.random() * 100 + 1));

                    if (stateCompe.events_female.length > 0) {
                      setStateCompe((val) => ({ ...val, events_female: [] }));
                    } else {
                      setStateCompe((val) => ({
                        ...val,
                        events_female: informationEvent
                          .filter((item) => item.event_gender == "Female")
                          .map((item) => item.event_name),
                      }));
                    }
                  }}
                  style={[
                    styles.buttonCheckbox,
                    {
                      backgroundColor:
                        stateCompe.events_female.length ==
                        informationEvent.filter(
                          (item) => item.event_gender == "Female"
                        ).length
                          ? "#2B6AB1"
                          : "#FFFFFF",
                      borderColor: validation.valid5 ? "#ff0000" : "#2B6AB1",
                    },
                  ]}
                ></TouchableOpacity>
                <Text
                  style={[
                    styles.textDetail,
                    { color: validation.valid5 ? "#ff0000" : "#2B6AB1" },
                  ]}
                >
                  SELECT ALL
                </Text>
              </View>
              <FlatList
                data={informationEvent}
                extraData={[stateCompe, validation]}
                numColumns={width >= 1280 && width < 1850 ? 1 : 2}
                scrollEnabled={width < 1280 ? true : false}
                key={keyindexFemale}
                renderItem={({ index, item }) => {
                  return (
                    item.event_gender == "Female" && (
                      <View
                        style={
                          width >= 1280
                            ? styles.viewCheckbox
                            : stylesResponsive.viewCheckbox
                        }
                      >
                        <TouchableOpacity
                          onPress={() => {
                            let Event = informationEvent;
                            const i = Event.findIndex((e) => {
                              return e.event_id === item.event_id;
                            });
                            if (i > -1) {
                              Event[i].select = !Event[i].select;
                            }
                            const Check = Event.every((e) => e.select === true);
                            Check
                              ? setCheckBoxAllFemale(true)
                              : setCheckBoxAllFemale(false);
                            setInformationEvent(Event);
                            setkeyindexFemale(
                              Math.floor(Math.random() * 100 + 1)
                            );
                            if (
                              stateCompe.events_female.filter(
                                (e) => e == item.event_name
                              ).length == 0
                            ) {
                              let events_female = stateCompe.events_female;
                              setStateCompe((val) => ({
                                ...val,
                                events_female: events_female.concat(
                                  item.event_name
                                ),
                              }));
                              setSelectEventFemale(
                                stateCompe.events_female.concat(item.event_name)
                              );
                            } else {
                              let Arr = stateCompe.events_female.filter(
                                (e) => e !== item.event_name
                              );
                              setSelectEventFemale(Arr);
                              setStateCompe((val) => ({
                                ...val,
                                events_female: Arr,
                              }));
                            }
                          }}
                          style={[
                            styles.buttonCheckbox,
                            {
                              backgroundColor:
                                stateCompe.events_female.filter((val) => {
                                  return val == item.event_name;
                                }).length > 0
                                  ? "#2B6AB1"
                                  : "#FFFFFF",
                              borderColor: validation.valid5
                                ? "#ff0000"
                                : "#2B6AB1",
                            },
                          ]}
                        ></TouchableOpacity>
                        <Text
                          style={[
                            styles.textDetail,
                            {
                              color: validation.valid5 ? "#ff0000" : "#2B6AB1",
                            },
                          ]}
                        >
                          {item.event_gender == "Female" && item.event_name}
                        </Text>
                        {
                          <TouchableOpacity
                            onPress={async () => {
                              console.log(item);
                              const response = await deleteEvent({
                                body: {
                                  event_id: item.event_id,
                                },
                                token: token.token,
                              });
                              if (response) {
                                recallgetCountriesEvent();
                              }
                            }}
                            style={{
                              width: 20,
                              height: 20,
                              borderRadius: 10,
                              backgroundColor: "#ff0000",
                              alignItems: "center",
                              marginLeft: 10,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: "Prompt",
                                color: "#fff",
                              }}
                            >
                              -
                            </Text>
                          </TouchableOpacity>
                        }
                      </View>
                    )
                  );
                }}
              />
              <View style={{ flexDirection: "row", marginTop: 20 }}>
                <TouchableOpacity
                  onPress={() => {
                    setAddEventMale({
                      ...AddEventMale,
                      event_gender: "Female",
                    });
                    setModalVisible(true);
                  }}
                  style={styles.viewAddItem}
                >
                  <View style={[[styles.buttonCheckbox, styles.buttonAction]]}>
                    <Entypo name="plus" size={22} color="#2B69B1" />
                  </View>
                  <Text style={styles.textDetail}>ADD EVENT</Text>
                </TouchableOpacity>
                {/* <TouchableOpacity
                  onPress={() => {
                    setDeleteF(true);
                  }}
                  style={[styles.viewAddItem, { marginLeft: 20 }]}
                >
                  <View style={[styles.buttonCheckbox, styles.buttonAction]}>
                    <Entypo name="minus" size={22} color="#2B69B1" />
                  </View>
                  <Text style={styles.textDetail}>DELETE EVENT</Text>
                </TouchableOpacity> */}
              </View>
              {width < 1280 && (
                <TouchableOpacity
                  onPress={onPress}
                  style={[
                    stylesResponsive.ButtonSave,
                    {
                      width: textButtonSave && width * 0.3,
                    },
                  ]}
                >
                  <Text style={styles.textSave}>
                    {textButtonSend && "create and send mail"}
                    {textButtonSave && "SAVE"}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
          <View style={{ width: "100%", paddingVertical: height * 0.05 }}>
            <Text
              style={[
                styles.textSubject,
                { alignSelf: "center", marginBottom: 10, marginTop: 20 },
              ]}
            >
              SELECT ROOM TYPE
            </Text>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <TouchableOpacity
                onPress={() => {
                  if (stateCompe.room_type_request.length == 4) {
                    setStateCompe((val) => ({ ...val, room_type_request: [] }));
                  } else {
                    setStateCompe((val) => ({
                      ...val,
                      room_type_request: [1, 2, 3, 4],
                    }));
                  }
                }}
                style={[
                  styles.buttonCheckbox,
                  {
                    backgroundColor:
                      stateCompe.room_type_request.length == 4
                        ? "#2B6AB1"
                        : "#FFFFFF",
                    borderColor: validation.valid6 ? "#ff0000" : "#2B6AB1",
                  },
                ]}
              ></TouchableOpacity>
              <Text
                style={[
                  styles.textDetail,
                  { borderColor: validation.valid6 ? "#ff0000" : "#2B6AB1" },
                ]}
              >
                SELECT ALL
              </Text>
            </View>
            <FlatList
              data={selectData}
              scrollEnabled={false}
              horizontal
              style={{}}
              renderItem={({ index, item }) => {
                return (
                  <View
                    style={
                      width >= 1280
                        ? [
                            {
                              flexDirection: "row",
                              width: width * 0.08,
                              marginTop: 15,
                              alignItems: "center",
                            },
                          ]
                        : stylesResponsive.viewCheckbox
                    }
                  >
                    <TouchableOpacity
                      onPress={() => {
                        console.log(index);
                        if (
                          stateCompe.room_type_request.filter(
                            (items) => items == index + 1
                          ).length > 0
                        ) {
                          setStateCompe((val) => ({
                            ...val,
                            room_type_request:
                              stateCompe.room_type_request.filter(
                                (items) => items != index + 1
                              ),
                          }));
                        } else {
                          setStateCompe((val) => ({
                            ...val,
                            room_type_request: val.room_type_request.concat(
                              index + 1
                            ),
                          }));
                        }
                      }}
                      style={[
                        styles.buttonCheckbox,
                        {
                          backgroundColor:
                            stateCompe.room_type_request.filter(
                              (items) => items == index + 1
                            ).length > 0
                              ? "#2B6AB1"
                              : "#FFFFFF",
                          justifyContent: "center",
                          borderColor: validation.valid6
                            ? "#ff0000"
                            : "#2B6AB1",
                        },
                      ]}
                    ></TouchableOpacity>
                    <Text
                      style={[
                        styles.textDetail,
                        { color: validation.valid6 ? "#ff0000" : "#2B6AB1" },
                      ]}
                    >
                      {item}
                    </Text>
                  </View>
                );
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewCreate: {
    maxWidth: 750,
    minWidth: 650,
    width: "40%",
    backgroundColor: "#FFFFFF",
    borderRadius: 34,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    paddingHorizontal: 21,
    paddingTop: 8,
    marginHorizontal: 52,
    marginVertical: 31,
  },
  viewCreateRespons: {
    width: "50%",
    backgroundColor: "#FFFFFF",
    borderRadius: 34,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    paddingHorizontal: 21,
    paddingTop: 8,
    marginHorizontal: 52,
    marginVertical: 31,
  },
  textSubject: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 19,
  },
  buttonPickImg: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 7,
  },
  viewPickImg: {
    width: 110,
    height: 50,
    borderRadius: 9,
    backgroundColor: "#E6E6E6",
    justifyContent: "center",
  },
  textUpPhoto: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    alignSelf: "center",
  },
  textSelectPhoto: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    marginLeft: 8,
  },
  textDetail: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonCheckbox: {
    width: 25,
    height: 25,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    borderRadius: 5,
    marginHorizontal: 5,
  },
  buttonSelectCalendar: {
    width: width * 0.1,
    height: 25,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderRadius: 5,
    justifyContent: "center",
    borderColor: "#7F9DBF",
    marginTop: 7,
  },
  textDate: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    paddingHorizontal: 10,
  },
  iconSelectDate: {
    alignSelf: "flex-end",
    paddingHorizontal: 5,
    borderLeftWidth: 1,
    position: "absolute",
    borderLeftColor: "#2B6AB1",
  },
  statistic: {
    num: {
      width: 30,
      height: 25,
      borderRadius: 5,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#7F9DBF",
      paddingHorizontal: 5,
      color: "#2B6AB1",
      fontFamily: "Prompt",
      marginTop: 7,
    },
  },
  textStatistic: {
    fontSize: 10,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: 5,
    marginTop: 7,
  },
  viewCheckbox: {
    flexDirection: "row",
    alignItems: "center",
    width: width * 0.1,
    marginTop: 15,
  },
  viewAddItem: {
    flexDirection: "row",
    alignItems: "center",
  },
  ButtonSave: {
    height: 36,
    backgroundColor: "#CCE4FF",
    borderRadius: 9,
    justifyContent: "center",
    marginVertical: 31,
  },
  textSave: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  checkbox: {
    width: "45%",
    marginVertical: 31,
    alignSelf: "flex-start",
  },
  checkboxRespons: {
    width: "35%",
    marginVertical: 31,
    alignSelf: "flex-start",
  },
  textInpuName: {
    height: 40,
    borderBottomWidth: 1,
    borderBottomColor: "#2B6AB1",
    paddingHorizontal: 10,
  },
  viewCkEditor: {
    borderWidth: 1,
    borderColor: "#2B6AB1",
  },
  viewCountry: {
    flexDirection: "row",
    alignItems: "center",
    width: "35%",
    marginTop: 15,
  },
  buttonAction: {
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },
  viewModal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewDetailModal: {
    width: width * 0.4,
    minHeight: height * 0.2,
    backgroundColor: "#FFFFFF",
    paddingVertical: 20,
    alignSelf: "center",
    borderRadius: 10,
  },
  textInputNameEventModal: {
    width: width * 0.2,
    height: 40,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    paddingHorizontal: 20,
  },
});
const stylesResponsive = StyleSheet.create({
  viewCreate: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    borderRadius: 34,
    borderWidth: 1,
    borderColor: "#2B6AB1",
    paddingHorizontal: 21,
    paddingTop: 8,
    alignSelf: "center",
    marginVertical: 31,
  },
  buttonSelectCalendar: {
    width: width * 0.35,
    height: 25,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderRadius: 5,
    justifyContent: "center",
    borderColor: "#7F9DBF",
    marginTop: 7,
  },
  checkbox: {
    width: width * 0.9,
    marginBottom: 20,
    alignSelf: "center",
  },
  viewCheckbox: {
    flexDirection: "row",
    alignItems: "center",
    width: width * 0.5,
    marginTop: 15,
  },
  ButtonSave: {
    height: 36,
    backgroundColor: "#FFFFFF",
    borderRadius: 9,
    justifyContent: "center",
    marginVertical: 31,
  },
});
